import { findIndexByPropertyValue } from 'utilities/collection';

export function getCorner(pivotX, pivotY, diffX, diffY, angle) {
  const distance = Math.sqrt(diffX * diffX + diffY * diffY);

  /// find angle from pivot to corner
  angle += Math.atan2(diffY, diffX);

  /// get new x and y and round it off to integer
  const x = pivotX + distance * Math.cos(angle);
  const y = pivotY + distance * Math.sin(angle);

  return { x: x, y: y };
}

export function getClientRect(rotatedBox) {
  const { x, y, width, height } = rotatedBox;
  const rad = rotatedBox.rotation;

  const p1 = getCorner(x, y, 0, 0, rad);
  const p2 = getCorner(x, y, width, 0, rad);
  const p3 = getCorner(x, y, width, height, rad);
  const p4 = getCorner(x, y, 0, height, rad);

  const minX = Math.min(p1.x, p2.x, p3.x, p4.x);
  const minY = Math.min(p1.y, p2.y, p3.y, p4.y);
  const maxX = Math.max(p1.x, p2.x, p3.x, p4.x);
  const maxY = Math.max(p1.y, p2.y, p3.y, p4.y);

  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  };
}

export function sortHostOnTop(attendees, meetingOwner) {

  const fromIndex = findIndexByPropertyValue(attendees, '_id', meetingOwner._id);
  const toIndex = 0;

  if (fromIndex === -1) {
    return attendees;
  }

  const element = attendees.splice(fromIndex, 1);

  attendees.splice(toIndex, 0, element[0]);

  const alteredAttendees = markHostFromAttendee(attendees, meetingOwner);

  return alteredAttendees;

}

export function markHostFromAttendee(attendees, meetingOwner) {

  const _attendees = [...attendees];

  for (let attendee of _attendees) {

    if (attendee._id === meetingOwner._id) {
      attendee.host = true;
    } else {
      attendee.host = false;
    }

  }

  return _attendees;

}

export function isSingleProducerMeetingSlotsAvailableError(exception) {

  if (exception.code !== 'ValidationError') {
    return false;
  }

  const metadata = exception.metadata;
  const errorIndex = findIndexByPropertyValue(metadata, 'keyword', 'isSingleProducerMeetingSlotsAvailable');

  if (errorIndex === -1) {
    return false;
  }

  return true;

}

export function computePrimaryContentDimensions(containerDimensions, hostVideoSettings) {

  if (!hostVideoSettings || !hostVideoSettings.width || !hostVideoSettings.height) {
    return {
      width: containerDimensions.width,
      height: containerDimensions.height,
      x: 0,
      y: 0
    };
  }

  const videoWidth = hostVideoSettings.width;
  const videoHeight = hostVideoSettings.height;
  const containerWidth = containerDimensions.width;
  const containerHeight = containerDimensions.height;

  const scaleWidth = containerWidth / videoWidth;
  const scaleHeight = containerHeight / videoHeight;

  const scale = Math.min(scaleWidth, scaleHeight);

  const targetWidth = videoWidth * scale;
  const targetHeight = videoHeight * scale;

  const x = (containerWidth - targetWidth) / 2;
  const y = (containerHeight - targetHeight) / 2;

  return { width: targetWidth, height: targetHeight, x: x, y: y };

}

export function computeSecondaryContentDimensions(containerDimensions, hostVideoSettings) {

  if (!hostVideoSettings || !hostVideoSettings.width || !hostVideoSettings.height) {
    return {
      width: 50,
      height: 50,
      boxWidth: 50,
      boxHeight: 50,
      x: containerDimensions.width - 50,
      y: containerDimensions.height - 50
    };
  }

  const boxDimensions = {
    width: 50,
    height: 50
  };

  const dimensions = computePrimaryContentDimensions(boxDimensions, hostVideoSettings);

  dimensions.boxWidth = boxDimensions.width;
  dimensions.boxHeight = boxDimensions.height;
  dimensions.x = containerDimensions.width - boxDimensions.width + dimensions.x;
  dimensions.y = containerDimensions.height - boxDimensions.height + dimensions.y;

  return dimensions;

}

export function getVideoSettingsFromElement(element) {

  if (!element) {
    return {
      width: 640,
      height: 480
    };
  }

  const width = element.videoWidth || 640;
  const height = element.videoHeight || 480;

  const settings = {
    width,
    height
  };

  return settings;

}